import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { PropsWithChildren, useEffect } from "react";
import { ModalFormProps } from "./UserMenu";

interface BaseDialogProps extends ModalFormProps {
  dialogTitle: string;
  resetFormValues: () => void;
  onSubmit: () => void;
}
export function BaseDialog({
  modalIsOpen,
  setModalIsOpen,
  dialogTitle,
  resetFormValues,
  onSubmit,
  children,
}: PropsWithChildren<BaseDialogProps>) {
  function handleCloseDialog() {
    setModalIsOpen(false);
  }
  const handleSubmit = () => {
    onSubmit();
    handleCloseDialog();
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(resetFormValues, [modalIsOpen]);
  return (
    <Dialog
      open={modalIsOpen}
      onClose={handleCloseDialog}
      role="editProfileDialog"
      fullWidth={true}
    >
      <DialogTitle>{dialogTitle}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions sx={{ bgcolor: "rgb(250,250,250)" }}>
        <Button onClick={handleCloseDialog}>Cancel</Button>
        <Button onClick={handleSubmit} variant="outlined">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
